module.exports = __webpack_public_path__ + "static/img/notice.fddf57d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notice.png
// module id = 6RTL
// module chunks = 1